module.exports = __webpack_public_path__ + "img/shinomontazhnyj-uchastok.6ea4135a.svg";